// Fisher-Yates pick of `count` items from `list`, never mutating the input.
// Used by vanity/+data.shared.js (server) and vanity/+Page.jsx (client fallback).
export function pickRandom(list, count) {
    const copy = [...(list ?? [])];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, count);
}
